module.exports = __webpack_public_path__ + "static/media/manabi_about_banner.83651c7a.png";